import App from "@fae/source/models/App.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"

export default function() {
    return {
        "func": function() {
            const player = App.game.player
            if(player == undefined) return

            player.key = player.key || "dev"

            const savegame = {
                "key": player.key,
                "navigationPath": "/games/school/overworld", // Navigation.path,
                "game": {
                    "player": player,
                    // "randomSeed": App.game.originalSeed,
                }
            }
            console.info("Saving game...", savegame)
            window.localStorage.setItem(App.game.key + "_savegame", JSON.stringify(savegame))
        }
    }
}
